"use client";

import { UsedProductFamily } from "@/@types";
import { sortArrayAlphabetically } from "@/utils/sorts";
import Link from "next/link";
import { usePathname } from "next/navigation";

type Props = {
    usedProductFamily: UsedProductFamily[];
};

export default function UsedProductsFamily({ usedProductFamily }: Props) {
    const pathName = usePathname();
    usedProductFamily = sortArrayAlphabetically(usedProductFamily, 'name');

    if (!Array.isArray(usedProductFamily) || usedProductFamily.length === 0) {
        return <p>No family available.</p>;
    }

    return (
        <div className="relative block bg-white p-2">
            <p className="py-2 lg:pl-3 text-lg font-bold">Categorías</p>
            <div className="flex flex-col">
                {usedProductFamily.map((family, index) => (
                    <Link
                        href={`${`/equipos-usados/${family.slug}`}`}
                        key={index}
                        className={`flex items-center justify-between lg:pl-4 py-1 text-base transition-colors ${pathName.includes(`/${family.slug}`)
                            ? "text-black bg-[#FFD201]"
                            : "text-gray hover:text-black"
                            } hover:bg-light01 hover:cursor-pointer`}
                    >
                        <span className="flex-1 truncate md:whitespace-normal">
                            {family.name}
                        </span>
                        <svg
                            className="w-4 h-4 ml-2 md:hidden"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </Link>
                ))}
            </div>
        </div>
    );
}
